import _ from 'lodash';

export const getLocale = (state) => _.get(state, 'locales.language', 'en');
